import React from 'react';

import { Button, createStyles, Drawer, Stack, Text } from '@mantine/core';
import { DatePickerInput, DatesRangeValue } from '@mantine/dates';
import { useDisclosure } from '@mantine/hooks';
import { IconChevronDown } from '@tabler/icons-react';
import KiloSelect from 'components/KiloSelect';
import {
  NOTIFICATION_TYPES,
  NotificationType,
  SearchFilters,
} from 'pages/private/owner/AthleteDetail/components/Communications/types';

const useStyles = createStyles(theme => ({
  header: {
    display: 'grid',
    gridTemplateColumns: 'auto auto min-content min-content',
    gridTemplateAreas: `'title title . filters'`,
    alignItems: 'center',
    gap: theme.spacing.sm,
    paddingBottom: theme.spacing.sm,
  },
  filters: {
    gridArea: 'filters',
  },
  title: {
    gridArea: 'title',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    marginLeft: theme.spacing.lg,
  },
  button: {
    width: 'min-content',
    marginLeft: 'auto',
  },
}));

interface ICommunicationsFiltersProps {
  searchFilters: SearchFilters;
  setSearchFilters: React.Dispatch<React.SetStateAction<SearchFilters>>;
  initialSearchFiltersValue: SearchFilters;
  orderingValue: string;
  timeType?: 'past' | 'upcoming';
  limit?: string;
  defaultEndDate?: string;
  openTabsDrawer: () => void;
}

const today = new Date();

const CommunicationsFilters = ({
  searchFilters,
  setSearchFilters,
  initialSearchFiltersValue,
  openTabsDrawer,
}: ICommunicationsFiltersProps): JSX.Element => {
  const { classes } = useStyles();

  const [isFiltersOpen, { open, close }] = useDisclosure(false);

  const handleDateChange = (value: DatesRangeValue): void => {
    setSearchFilters(prev => ({ ...prev, date: value }));
  };

  const handleNotificationTypeChange = (value: NotificationType): void => {
    setSearchFilters(prev => ({ ...prev, notificationType: value }));
  };

  const handleClearFilters = (): void => {
    setSearchFilters(initialSearchFiltersValue);
  };

  return (
    <div className={classes.header}>
      <Text size='md' fw='bold' className={classes.title} onClick={openTabsDrawer}>
        Communications
        <IconChevronDown size={16} style={{ marginLeft: 4 }} />
      </Text>

      <Button onClick={open} className={classes.filters} size='xs'>
        Filters
      </Button>

      <Drawer position='bottom' opened={isFiltersOpen} onClose={close}>
        <Stack spacing='sm' justify='flex-start'>
          <Button color='red' onClick={handleClearFilters} className={classes.button}>
            Clear Filters
          </Button>
          <DatePickerInput
            value={searchFilters.date}
            onChange={handleDateChange}
            valueFormat='YYYY MMM DD'
            type='range'
            clearable
            {...{ placeholder: 'Select date range' }}
            maxDate={today}
            allowSingleDateInRange
          />
          <KiloSelect
            onChange={handleNotificationTypeChange}
            data={NOTIFICATION_TYPES}
            placeholder={'Select notification type'}
            value={searchFilters.notificationType || ''}
          />
        </Stack>
      </Drawer>
    </div>
  );
};

export default CommunicationsFilters;
